import { Stack } from "@mui/material";
import { EMPTY_CHARACTER } from "@pulse/shared-components";
import {
  Button,
  SearchField,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SEARCH_FILED_WIDTH = "360px";

export interface EmailTemplateTableFilterType {
  value: string;
}

interface EmailTemplateTableFilterProps {
  filter: EmailTemplateTableFilterType;
  setFilter: (filter: EmailTemplateTableFilterType) => void;
}

export const EmailTemplateTableFilter: React.FC<EmailTemplateTableFilterProps> =
  observer(({ filter, setFilter }) => {
    const [searchQuery, setSearchQuery] = useState(filter);

    const { t } = useTranslation();
    const spacing = useSpacing();

    return (
      <Stack direction="row" justifyContent="end" gap={spacing.spaceSM}>
        <SearchField
          name="emailTemplateTableSearchField"
          placeholder={t("common.search")}
          value={searchQuery.value}
          onTextChange={(value) => setSearchQuery({ value })}
          onClear={() => {
            setSearchQuery({ value: EMPTY_CHARACTER });
            setFilter({ value: EMPTY_CHARACTER });
          }}
          width={SEARCH_FILED_WIDTH}
          allowClearField
        />
        <Button
          name="emailTemplateTableSearchFieldButton"
          label={t("common.search")}
          size="large"
          variant="filled"
          onClick={() => setFilter(searchQuery)}
          disabled={!searchQuery.value.trim()}
        />
      </Stack>
    );
  });
